import React, { useEffect } from "react";

const AnimatedMissionVisionValueSection = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          entry.target.classList.toggle("show", entry.isIntersecting);
        });
      },
      { threshold: 0.2 }
    );

    const elements = document.querySelectorAll(".fade-in-left, .fade-in-right");
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <section className="about-section gradient-bg">
        <div className="container">
          <div className="about-block">
            <div className="about-image fade-in-left">
              <img src="assets/img/icon/missionImage.jpg" alt="Our Mission" />
            </div>
            <div className="about-content fade-in-right">
              <h3 className="about-title">Our Mission</h3>
              <p className="about-text">
                Our mission is to empower businesses with reliable, innovative,
                and bespoke digital solutions. We aim to deliver web
                development, digital services, and technology-oriented
                strategies that are unique to each client. Through quality,
                transparency, and client satisfaction, we facilitate the growth,
                competition, and success of our clients in the digital space. We
                believe in cultivating long-lasting relationships founded on
                trust and performance. Every single assignment taken up is
                treated with great respect and sincerity; hence, the results
                must actually count and add great value to the business we
                collaborate with.
              </p>
            </div>
          </div>

          <div className="about-block reverse">
            <div className="about-image fade-in-left">
              <img src="assets/img/icon/visionImage.jpg" alt="Our Vision" />
            </div>
            <div className="about-content fade-in-right">
              <h3 className="about-title">Our Vision</h3>
              <p className="about-text">
                Our vision is to be a leading agency of digital services
                grabbing greater notoriety for its excellence, innovations, and
                customer success. We aim to draft a future where small and
                medium-sized companies can acquire potent, scalable, and
                easy-to-use technology solutions for their growth. We aim to set
                very high standards in web design, online marketing, and online
                solutions by constantly evolving according to the digital
                landscape. We envision the era where technology acts as a bridge
                between businesses and their customers, and we want to be at the
                forefront in making that bridge a bit stronger and smarter and
                hence more meaningful.
              </p>
            </div>
          </div>

          <div className="about-block">
            <div className="about-image fade-in-left">
              <img src="assets/img/icon/our_goal.jpg" alt="Our Value" />
            </div>
            <div className="about-content fade-in-right">
              <h3 className="about-title">Our Goal</h3>
              <p className="about-text">
                Our goal is to offer practical and efficient digital solutions
                from which there is a measurable benefit for the businesses. We
                focus on digital enhancement for our clients along with their
                efficiency and foster their growth in the long run. Every
                strategy that we lie down and every service we provide are
                relevant to the client's goals with respect to their needs in
                the market. We want to make complex digital issues simple with
                solutions that are appealing and easy to follow. Be it a website
                for the client to sell his products or an application with
                mobile capabilities coupled with data and marketing management,
                whatever we do has to add value and generally create a positive
                change within a business.
              </p>
            </div>
          </div>
        </div>

        {/* Internal CSS */}
        <style>{`
          .about-section {
            padding: 4rem 1rem;
            background-color: #b6dafc;
          }

          .about-block {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-bottom: 2rem;
            gap: 2rem;
          }

          .about-block.reverse {
            flex-direction: row-reverse;
          }

          .about-image, .about-content {
            flex: 1;
            width: 50%;
          }

          .about-image img {
            width: 100%;
            height: 300px;
            border-radius: 1rem;
            box-shadow: 0 10px 20px rgba(0,0,0,0.1);
          }

          .about-title {
            color: #18336c;
            margin-bottom: 1rem;
          }

          .about-text {
            color: #444;
          }

          .fade-in-left, .fade-in-right {
            opacity: 0;
            transition: all 0.6s ease-out;
          }

          .fade-in-left {
            transform: translateX(-50px);
          }

          .fade-in-right {
            transform: translateX(50px);
          }

          .fade-in-left.show, .fade-in-right.show {
            opacity: 1;
            transform: translateX(0);
          }

          .change-background-color{
            padding: 3rem 0px;
            background-color: #bfcee0;
          }

          @media (max-width: 768px) {
            .about-block, .about-block.reverse {
              flex-direction: column;
              text-align: center;
            }

            .about-image, .about-content {
              width: 83%;
            }

            .about-image img {
              height:180px;
            }
          }

          .gradient-bg {
            padding: 5rem 1rem;
            color: white;
            background: linear-gradient(135deg, #64AFF5, #9CC0F7, #B8E7FC, #B8E7FC);
            background-size: 400% 400%;
            animation: gradientShift 15s ease infinite;
        }

        @keyframes gradientShift {
          0% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 100% 50%;
          }
          100% {
            background-position: 0% 50%;
          }
        }

        `}</style>
      </section>
    </>
  );
};

export default AnimatedMissionVisionValueSection;
